let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2xo8U")).then(() => parcelRequire('2dHqG'));